/*
 * FELGER · Motion system
 * - Scroll-triggered reveal: elementos con [data-fg-reveal], [data-fg-reveal-up], [data-fg-reveal-scale]
 * - Parallax sutil: [data-fg-parallax] (speed 0.2-0.4)
 * - Text-split reveal: [data-fg-splittext]
 * - Cursor glow follow: [data-fg-cursor-glow]
 * Respeta prefers-reduced-motion. Se auto-desactiva en móviles de gama baja.
 */
(function() {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lowMem = navigator.deviceMemory && navigator.deviceMemory < 2;

  // Progressive enhancement: activamos motion solo si JS anda y no hay reduced-motion.
  if (reduced || lowMem) {
    // Sin motion — todo visible desde el principio; no agregamos .fg-motion.
    return;
  }
  document.documentElement.classList.add('fg-motion');

  // Failsafe: si el observer no dispara en 2.5s, revelamos todo forzadamente (bypass transition estancada).
  setTimeout(function() {
    document.querySelectorAll('[data-fg-reveal],[data-fg-reveal-up],[data-fg-reveal-scale]').forEach(function(el){
      if (!el.classList.contains('fg-revealed')) {
        el.classList.add('fg-revealed');
      }
      // Si después de 400ms de agregar la clase sigue con opacity 0, forzamos visible.
      setTimeout(function() {
        if (parseFloat(getComputedStyle(el).opacity) < 0.9) {
          el.classList.add('fg-force-visible');
        }
      }, 400);
    });
  }, 2500);

  // ---- Scroll reveal ----
  if ('IntersectionObserver' in window) {
    var revealIO = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fg-revealed');
          revealIO.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    document.querySelectorAll('[data-fg-reveal],[data-fg-reveal-up],[data-fg-reveal-scale]').forEach(function(el){
      revealIO.observe(el);
    });
  }

  // ---- Parallax (sutil, no aggressive) ----
  var parallaxEls = document.querySelectorAll('[data-fg-parallax]');
  if (parallaxEls.length && 'requestAnimationFrame' in window) {
    var lastY = window.scrollY, ticking = false;
    function update() {
      parallaxEls.forEach(function(el) {
        var rect = el.getBoundingClientRect();
        var speed = parseFloat(el.getAttribute('data-fg-parallax')) || 0.25;
        var offset = (window.innerHeight - rect.top) * speed * 0.15;
        // clamp
        offset = Math.max(-80, Math.min(80, offset));
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    function onScroll() {
      lastY = window.scrollY;
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  // ---- Cursor glow on primary CTAs (desktop only, pointer:fine) ----
  var supportsHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (supportsHover) {
    var glowEls = document.querySelectorAll('[data-fg-cursor-glow], .fg-btn--primary');
    glowEls.forEach(function(btn) {
      btn.classList.add('fg-cursor-glow');
      btn.addEventListener('mousemove', function(e) {
        var rect = btn.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        btn.style.setProperty('--fg-mx', x + 'px');
        btn.style.setProperty('--fg-my', y + 'px');
      });
    });
  }

  // ---- Text-split reveal (headings del hero) ----
  document.querySelectorAll('[data-fg-splittext]').forEach(function(el) {
    var text = el.textContent;
    var chars = text.split('');
    el.textContent = '';
    chars.forEach(function(c, i) {
      var span = document.createElement('span');
      span.className = 'fg-char';
      span.style.setProperty('--fg-char-i', i);
      span.textContent = c === ' ' ? ' ' : c;
      el.appendChild(span);
    });
    el.classList.add('fg-splittext-ready');
  });
})();

/* FELGER · Marca cards de producto cuya imagen es un recorte de PDF de catalogo
   (patron sku-*-p\d+ o -pNN-NN en la url). Agrega la clase .fg-img-referencial
   al contenedor de imagen, que la CSS decora con un badge "IMG REFERENCIAL". */
(function() {
  var PDF_RE = /-p\d{1,4}-\d{1,3}[_\-]|\/sku-[^\/]*-p\d{1,4}/i;
  function mark(root) {
    var imgs = (root || document).querySelectorAll('img[src*="cdn.shopify.com"], img[src*="/cdn/shop/"]');
    imgs.forEach(function(img) {
      var src = img.getAttribute('src') || img.getAttribute('data-src') || '';
      if (!src || !PDF_RE.test(src)) return;
      var url;
      try {
        url = new URL(src, window.location.href);
      } catch (e) {
        return;
      }
      var sameOriginShopifyPath = url.origin === new URL(window.location.href).origin && url.pathname.indexOf('/cdn/shop/') !== -1;
      if (url.hostname !== 'cdn.shopify.com' && !sameOriginShopifyPath) return;
      var card = img.closest('.card__media, .media, .card-wrapper, .grid__item');
      if (card && !card.classList.contains('fg-img-referencial')) {
        card.classList.add('fg-img-referencial');
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { mark(document); });
  } else {
    mark(document);
  }
  // Re-scan on dynamic loads (predictive search, cart drawer, filter reload)
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function(muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          mark(document);
          break;
        }
      }
    });
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();
